import { html, render, TemplateResult } from "lit";
import { csvToJson } from "../components/csv-to-json";
import { getWERSRatingResults, WERSRatingResults } from "../components/ratings";
import { fetchCSV } from "../data/search-data";
import { PageResult, RequestPage, TableView } from "./table-view";
import { ViewBase } from './view-base';
import { hash, pageNames } from "./view-consts";


/*this lets us easily bypass the typescript jquery definitions which are not what we want to use for datatables as the
typescript is out of date.
DataTables must be added to the main page directly, not compiled in*/
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $j = $.fn as any;


interface Skylight {
    skylightId: string;
    prime: string;
    frameDesc: string;
    skylightType: string;
    material: string;
    uval: string;
    shgc: string;
    tv: string;
    as4285: string;
}

class SkylightTable extends TableView<Skylight> {
    data: Skylight[] | null = null;
    async getRowsFromServer(request: RequestPage): Promise<PageResult<Skylight>> {
        if (!this.data) {
            this.data = await fetchCSV("/api/wers/data/skylights.csv") as Skylight[];
        }
        return {
            count: this.data.length,
            pageCount: this.pageLength(),
            pageIndex: request.pageIndex,
            pageSize: request.pageSize,
            results: this.data.slice(request.pageIndex * request.pageSize, (request.pageIndex * request.pageSize) + this.pageLength())
        };
    }
    getColumns(): any[] {
        /* // datatable column definitions
                {

                    title: '<i class="fas fa-star"></i>',
                    width: "40px",
                    data: "windowId",
                    render: (value) => {
                        const favClassVal = (this.isFavourite(value) ? "fas " : "far ") + " fa-star text-warning favourite ";
                        const jobClassVal = (this.isJob(value) ? "text-success " : "text-secondary ") + " fas fa-home  job";
                        const val = `<i class="${favClassVal}" ></i> <i class="${jobClassVal}"  ></i>`;
                        return val;
                    }
                },
        */
        return [
            {
                title: "Skylight ID",
                width: "100px",
                data: "skylightId"
            },
            {
                title: "Manufacturer",
                width: "100px",
                data: "prime"
            },
            {
                title: "Frame",
                width: "600px",
                data: "frameDesc"
            },
            /*
            {
                title: "Cooling Stars",
                width: "100px",
                data: "skylightId",
                render: (value: string, _type: never, row: Skylight) => {
                    const r = getWERSRatingResults(parseFloat(row.uval), parseFloat(row.shgc), "");
                    return `<wers-stars value="${r.coolingStars ?? 0}" type="cool"></wers-stars>`;
                }
            },
            {
                title: "Heating Stars",
                width: "100px",
                data: "skylightId",
                render: (value: string, _type: never, row: Skylight) => {
                    const r = getWERSRatingResults(parseFloat(row.uval), parseFloat(row.shgc), "");
                    return `<wers-stars value="${r.heatingStars ?? 0}" type="heat"></wers-stars>`;
                }

            },
            {
                title: "Daylighting Stars",
                width: "100px",
                data: "skylightId",
                render: (value: string, _type: never, row: Skylight) => {
                    return "Pending";
                }

            },
            */
            {
                title: "Usky",
                width: "100px",
                data: "uval",
                render: (value: string, _type: never, row: Skylight) => {
                    return parseFloat(value).toFixed(1);
                }

            },
            {
                title: "SHGCw",
                width: "100px",
                data: "shgc",
                render: (value: string, _type: never, row: Skylight) => {
                    return parseFloat(value).toFixed(2);
                }

            },
            {
                title: "AS4285",
                width: "100px",
                data: "as4285",
                render: (value: string, _type: never, row: Skylight) => {
                    return value === "a"
                        ? `<i class="fas fa-check text-success"></i>`
                        : ``;
                }
            }

        ];
    }

}

export class SkyLightsView extends ViewBase {
    private table: SkylightTable;
    constructor(name: string, globalRenderEvent: () => Promise<void>) {
        super(name, globalRenderEvent);
        this.table = new SkylightTable();
    }
    protected doConstruct(): void {

    }
    protected async onPageActivated(active: Boolean) {
        this.table.render();
    }

    public async template(): Promise<TemplateResult> {
        const date = new Date();
        return html`
        <div class="text-center">
            <h1 class="">Skylights</h1>
            <div class="container-fluid">
                ${this.table.ui}
            </div>
        </div>`;
    }

}
